import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAWhenEffective() {
  const { setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ effectiveImmediately, setEffectiveImmediately ] = useState(true);
  
  useScrollToTop();

  const handleBack = useCallback(() => {
    navigate('../when-to-make');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      effective_immediately: effectiveImmediately 
    }));
    navigate('../personal-info');
  }, [ effectiveImmediately, setPowerOfAttorney, navigate ]);

  const handleImmediateChange = useCallback(() => {
    setEffectiveImmediately(true);
  }, []);

  const handleIncapacityChange = useCallback(() => {
    setEffectiveImmediately(false);
  }, []);
  
  return (
    <div className="new-poa-when-effective screen-container screen">
      <ScreenHeader
        title="When Your Document Takes Effect"
        description="Choose when your Power of Attorney becomes effective"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>Understanding When Your POA Takes Effect</h3>
        <p>
          A Durable Power of Attorney can be designed to take effect in different ways. 
          You have two main options:
        </p>

        <div className="effect-options">
          <div className="effect-option">
            <label htmlFor="effective-immediately" className="effect-option-label">
              <input
                type="radio"
                id="effective-immediately"
                name="effect-timing"
                value="immediately"
                checked={effectiveImmediately}
                onChange={handleImmediateChange}
              />
              <div className="effect-option-content">
                <h4>Effective Immediately</h4>
                <p>Your agent can act on your behalf as soon as the document is signed and notarized.</p>
              </div>
            </label>
            <ul>
              <li>Agent can act right away if needed</li>
              <li>No need to prove incapacity</li>
              <li>Maximum flexibility for your agent</li>
            </ul>
          </div>

          <div className="effect-option">
            <label htmlFor="effective-upon-incapacity" className="effect-option-label">
              <input
                type="radio"
                id="effective-upon-incapacity"
                name="effect-timing"
                value="upon-incapacity"
                checked={!effectiveImmediately}
                onChange={handleIncapacityChange}
              />
              <div className="effect-option-content">
                <h4>Effective Upon Incapacity</h4>
                <p>Your agent can only act if you become incapacitated and unable to make decisions yourself. This requires a doctor's certification of incapacity.</p>
              </div>
            </label>
            <ul>
              <li>You maintain full control while capable</li>
              <li>Requires medical certification to activate</li>
              <li>May cause delays in emergency situations</li>
            </ul>
          </div>
        </div>

        <div className="important-note">
          <h4>Important Considerations:</h4>
          <p>
            Most people choose "Effective Immediately" because it provides the most flexibility 
            and ensures your agent can act quickly if needed. You can always revoke the document 
            at any time if you change your mind.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
